import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshUser = useCallback(async () => {
    const token = localStorage.getItem("webtu_token");
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      const { data } = await api.get("/me");
      setUser(data.user);
    } catch (e) {
      localStorage.removeItem("webtu_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refreshUser(); }, [refreshUser]);

  const login = (token, u) => {
    localStorage.setItem("webtu_token", token);
    setUser(u);
  };
  const logout = () => {
    localStorage.removeItem("webtu_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
